<template>
    <div>
        <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>
                Dashboard
                <small>Control panel</small>
            </h1>
            <ol class="breadcrumb">
                <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
                <li class="active">Dashboard</li>
            </ol>
        </section>

        <!-- Main content -->
        <section class="content">

          {{ pagination }}

          <div class="box">
            <!--<div class="box-header with-border">-->
              <!--<h3 class="box-title">Monthly Recap Report</h3>-->
            <!--</div>-->
            <div class="box-body">
              <div class="row">
                <div class="col-sm-12">
                  <search-filters v-on:searchParamsChanged="onSearchParamsChanged"></search-filters>
                  <search-pagination-component
                      :prev="pagination.prev"
                      :current="pagination.page"
                      :next="pagination.next"
                      :pages="pagination.pages"
                      v-on:pageupdate="onPageUpdate" />
                </div>
              </div>
            </div>
          </div>
          <car-graph-cell-component class="box" v-for="car in cars" :key="car.id" :car="car" :dates="dates" />

        </section>
        <!-- /.content -->
    </div>
</template>

<!--suppress ES6ModulesDependencies -->
<script>
import CarGraphCellComponent from '@/components/custom/CarGraphCellComponent'
import GraphComponent from '@/components/GraphComponent'
// import { EventBus } from '@/utils/EventBus'
import SearchFilters from '@/components/custom/SearchFilters'
// import VueSparklines from 'vue-sparklines'
import moment from 'moment'
import webservices from '@/utils/webservice'
import SearchPaginationComponent from '@/components/custom/SearchPaginationComponent'
export default {
  name: 'PageDashboardComponent',
  components: { SearchFilters, GraphComponent, CarGraphCellComponent, SearchPaginationComponent },
  data () {
    return {
      data: [],
      busy: false,
      carsData: [],
      cars: [],
      lastNetworkSearch: -1,
      timeoutRef: null,
      search: {
        params: ''
      },
      pagination: {
        page: 0,
        requestPage: 0,
        pages: 10,
        items: 10,
        prev: 0,
        next: 0
      }
    }
  },
  computed: {
    dates: () => {
      let dates = []
      for (let k = 30; k > 1; k--) {
        let unixTimestamp = moment().subtract(k, 'days').endOf('day').add(1, 'second').add(1, 'hour').unix()
        dates.push(unixTimestamp)
      }
      return dates
    }
  },
  mounted () {
    // eslint-disable-next-line no-undef
    Chart.pluginService.register({
      afterUpdate: function (chart) {
        if (chart.hasOwnProperty('config') && chart.config.hasOwnProperty('data') && chart.config.data.hasOwnProperty('datasets')) {
          if (chart.config.data.datasets instanceof Array) {
            chart.config.data.datasets.forEach(dataset => {
              if (dataset.hasOwnProperty('events')) {
                let metaData = dataset['_meta'][chart.id].data
                if (metaData !== null) {
                  dataset.events.forEach((event, index) => {
                    if (event !== null && metaData[index] !== undefined && metaData[index].hasOwnProperty('_model')) {
                      metaData[index]['_model'].pointStyle = event.icon
                    }
                  })
                }
              }
            })
          }
        }
      }
    })

    // this.$store.dispatch('analytics/fetchAnalyticsForDailyPeriodicityOfCars', { cars: [1029, 1665, 1669], periodicity: 'daily' }).then(data => {
    //   this.carsData = this.$store.getters['analytics/getCars']
    //   EventBus.$emit('carDataUpdate')
    // })

    this.loadPageWithParamsAndPageItems(``)
  },
  methods: {

    loadMore () {
      this.busy = true
      this.onPageUpdate(this.pagination.page + 1).then(() => {
        this.busy = false
      })
    },

    onPageUpdate (requestedPage) {
      console.log('onPageUpdate', requestedPage)
      this.pagination.requestPage = requestedPage
      return this.loadPageWithParamsAndPageItems()
    },
    onSearchParamsChanged (payload) {
      (async () => {
        let now = new Date().getTime()
        let ts = now - this.lastNetworkSearch
        if (ts < 1500) {
          clearTimeout(this.timeoutRef)
          await new Promise(resolve => {
            this.timeoutRef = setTimeout(resolve, 1500 - ts)
          })
        }
        this.search.params = payload.params
        this.lastNetworkSearch = now
        this.loadPageWithParamsAndPageItems()
      })()
    },

    loadPageWithParamsAndPageItems () {
      return new Promise((resolve, reject) => {
        webservices.search.findCarsDatatable(this.search.params, this.pagination.requestPage, this.pagination.items).then(results => {
          this.pagination.pages = Math.ceil(results.recordsFiltered / this.pagination.items)
          this.pagination.page = this.pagination.requestPage
          this.pagination.prev = this.pagination.page > 1 ? this.pagination.page - 1 : 0
          this.pagination.next = this.pagination.page + 1 <= this.pagination.pages ? this.pagination.page + 1 : 0

          results.data.forEach(car => {
            this.cars.push(car)
          })
          // this.cars = results.data
          resolve()
        }).catch(e => {
          console.error(e)
          reject(e)
        })
      })
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/PageDashboardComponent.vue